import { useState } from "react";
import { Alert, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";

function EmailVarification() {
  const [loading, setLoading] = useState(true);

  // Simulate loading process
  setTimeout(() => setLoading(false), 2000);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" role="status" className="mb-3">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p>Verifying your email...</p>
        </div>
      ) : (
        <div
          className="card shadow-lg p-4 text-2xl m-3 text-center"
          style={{ maxWidth: "600px" }}
        >
          <div className="text-center mb-4">
            <h4>Email Verified!</h4>
          </div>

          <Alert variant="success" className="text-start">
            Your email has been successfully verified. You can now proceed to
            the login page.
          </Alert>

          <div className="text-center mt-3">
            <Link to="/">
              <button className="btn btn-primary w-100">Go to Login</button>
            </Link>
          </div>

          <span className="mt-3">
            If the above button does not work, copy and paste the following URL
            into your browser: <br />
            <a href="http://localhost:3000/" className="text-primary underline">
              http://localhost:3000/
            </a>
          </span>
        </div>
      )}
    </div>
  );
}

export default EmailVarification;
